import React, { useState } from 'react';
import { Box, TextField } from '@mui/material';
import TABHintBubble from './TABHintBubble';

/**
 * AutoCompleteField Component
 * Enhances TextField with TAB-to-accept functionality for AI recommendations
 */
const AutoCompleteField = ({ recommendation, value, onChange, ...props }) => {
  const [showBubble, setShowBubble] = useState(false);

  // Helper function to clean recommendation text for actual input
  const cleanRecommendationText = (text) => {
    if (!text) return '';
    
    // Remove common prefixes that are meant for placeholder display only
    return text
      .replace(/^e\.g\.,\s*/i, '')           // Remove "e.g., " prefix
      .replace(/^for example,\s*/i, '')     // Remove "For example, " prefix
      .replace(/^example:\s*/i, '')         // Remove "Example: " prefix
      .trim();
  };

  const handleFocus = () => {
    // Show bubble if field is empty and has a recommendation
    if (!value && recommendation) {
      setShowBubble(true);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Tab' && showBubble && recommendation) {
      e.preventDefault(); // Prevent default tab behavior
      // Fill field with cleaned recommendation (without "e.g., " prefix)
      const cleanedText = cleanRecommendationText(recommendation);
      onChange({ target: { value: cleanedText } });
      setShowBubble(false);
    }
  };

  const handleChange = (e) => {
    // Hide bubble when user starts typing
    setShowBubble(false);
    onChange(e);
  };

  const handleBlur = () => {
    // Hide bubble when field loses focus
    setShowBubble(false);
  };

  return (
    <Box sx={{ position: 'relative', width: '100%', flex: 1 }}>
      <TextField
        value={value}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        placeholder={recommendation}
        multiline
        minRows={1}
        maxRows={4}
        {...props}
      />
      {showBubble && <TABHintBubble />}
    </Box>
  );
};

export default AutoCompleteField;